import React, {useContext, useEffect, useState} from "react";
import "./App.css";
import AuthErrorPage from "./views/unprotectedPages/AuthErrorPage";
import {KeycloakContext} from "./views/contextProviders/KeycloakProvider";
import {removeOverlaidMessages} from "./utility/utility";
import {FormattedMessage} from "react-intl";
import {InternalGlobalMenu} from "./components/InternalGlobalMenu";
import {TileApplications} from "@spg/component_library";
import {Outlet, useLocation} from "react-router-dom";
import API from "./logic/API";
import {Resolution} from "./logic/FetchResolver";
import NavBar from "./components/NavBar";
import {ModalProvider} from "./views/contextProviders/ModalProvider";

function App() {
  const {initialized, authenticated} = useContext(KeycloakContext);
  const location = useLocation();

  const [applications, setApplications] = useState<
    Resolution<TileApplications>
  >({
    success: false,
    unresolved: true,
  });

  // Fills globalMenu with app list
  useEffect(() => {
    if (authenticated)
      API.getApplications().then((result) => setApplications(result));
  }, [authenticated]);

  // Unauthenticated
  if (!initialized || !authenticated)
    return (
      <AuthErrorPage
        reason="unauthenticated"
        afterTimeout={removeOverlaidMessages}
      />
    );

  return (
    <div className="app">
      <a className="app__skip sr-only" href={location.pathname + "#main"}>
        <FormattedMessage id="app.action.skipToContent" />
      </a>
      <NavBar />
      <InternalGlobalMenu applications={applications} />
      <main id="main" className="app__main">
        <div className="app__content">
          <ModalProvider>
            <Outlet />
          </ModalProvider>
        </div>
      </main>
    </div>
  );
}

export default App;
